module.exports = __webpack_public_path__ + "media/src/components/SubscriptionPlans/img/wave-1d5b9ff7c4b91c6f15b5eacae78d5bd2.svg";